export default {"src":"/_next/static/media/goBack.f38b7e9c.svg","height":19,"width":11,"blurWidth":0,"blurHeight":0};